import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Modal, Button } from "react-bootstrap";
class NotificationModal extends React.Component {
  close() {
    this.props.closeModal();
  }

  confirm() {
    this.props.successCallback();
    this.close();
  }

  stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    let bootstrapStyles = ["info", "success", "warning", "danger"];

    let variant =
      this.props.variant && bootstrapStyles.indexOf(this.props.variant) !== -1
        ? this.props.variant
        : "info";
    //dialogAs={DraggableModalDialog}
    return !this.props.isMinimized ? (
      <Modal show={true} size={this.props.isMinimized === false ? "lg" : "md"}>
        <Modal.Header>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>{this.props.content}</Modal.Body>

        <Modal.Footer>
          {this.props.isMinimized === false && (
            <Button variant={variant} onClick={() => this.confirm()}>
              <FormattedMessage id="Ignore.Definitely" />
            </Button>
          )}
          <Button
            variant={this.props.isMinimized === false ? "success" : variant}
            onClick={
              this.props.isMinimized === false
                ? () => this.props.setState({ isMinimized: true })
                : () => this.confirm()
            }
          >
            <FormattedMessage
              id={
                this.props.isMinimized === false ? "Remind.Me.Later" : "Close"
              }
            />
          </Button>
        </Modal.Footer>
      </Modal>
    ) : (
      <div className="position-relative">
        <div className="fixed-bottom">
          <Button
            variant="danger"
            className="ml-2 mb-2"
            onClick={() => this.props.setState({ isMinimized: false })}
          >
            <i className="fa fa-bell" />
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationModal);
